import { cn } from "@elit-hair/elitklinik-shared";
import { ListItem } from "@mui/material";

function TableListItem({ children, className }: { children: React.ReactNode; className?: string[] }) {
    return (
        <ListItem
            className={cn(
                "flex items-center gap-2  bg-gradient-to-r from-gray-50 to-gray-100  text-gray-800   rounded-lg border border-gray-200/60  shadow-sm",
                className
            )}
        >
            {children}
        </ListItem>
    );
}
export default TableListItem;
